<template>
  <div id="TipCreate">
    <!-- success msg component 
    <Success :msg="msg" v-show="success" />
    <ProductForm :user="user" @submit-form="saveUser" hasCustomer=true buttonText="Guardar" />
     -->
    <ProductForm :submitForm="addRow" buttonText="Guardar" hasReset=true hasTips=true />
  </div>
</template>

<script>
import{ mapMutations,mapState } from "vuex";
import ProductForm from "@/components/MessageForm";
//import Success from "./Success";
// import baseApi from '@/services/baseApi';
import icheckApi from '@/services/icheckApi';
// import router from '@/router';

export default {
  name: "TipCreate",
  computed:{
    ...mapState(['currentUser']),    
  },
  components: {
    ProductForm,
    //Success,
  },
  props: {
    user: Object,
  },
  data() {
    return {
      success: false,
      msg: "",
    };
  },
  methods: {
    ...mapMutations(["showLoading","hiddenLoading","changeBreadcrumbs"]),
    async addRow(ProductInfo){
      this.showLoading({titulo:"Almacenando información",color:"warning"})
      // alert (ProductInfo.name);

      try{         
        let name=ProductInfo.name;
        let consejo=ProductInfo.consejo;
        let tags=ProductInfo.tags;

        await icheckApi().post(`/tips`,JSON.stringify({ name,consejo,tags })).then((response)=>{       
            if(!response.data.error){                            
              this.$swal("Genial!",response.data.message, "success");
            }else{
              // this.$swal("Error!",response.data.message, "error");
              this.$swal("Error!",response.data.message+': <br/>'+JSON.stringify(response.data.validate), "error"); 
            }                                   
        });
      }catch(error){        
          this.$swal("Error!",error.message+"<br/> Intente Nuevamente o verifique todos los campos", "error");        
      } finally{
        this.hiddenLoading()
      }
    },
  },
};
</script>